<template>
    <b-col cols="12" class="filter-form mt-2">
        <b-card>
            <b-card-body>

                <form class="form-sample filter-inner mb-4 p-4">
                    <b-row>
                        <b-col cols="12" class="mt-0">
                            <label for="input-type" class="mb-2"><strong>{{ $translate('activity_types')
                                    }}</strong></label>

                            <multiselect id="input-type" :placeholder="$translate('select_activity_types')"
                                :deselectLabel="deselectLabel" :selectedLabel="selectedLabel" :selectLabel="selectLabel"
                                v-model="typeOptions" :multiple="true" :options="orderTypes" label="name" track-by="id"
                                :close-on-select="false">
                            </multiselect>
                        </b-col>


                        <b-col class="mt-4" md="12" cols="12">
                            <label for="input-customer_group_id" class="mb-3"><strong>{{
                                $translate('customer_groups')
                                    }}</strong></label>
                            <b-form-select id="input-customer_group_id" v-model="queryForm.customer_group_id"
                                value-field="id" text-field="name" :options="customerGroups">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_customer_group')
                                        }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col class="mt-4" md="6" cols="12" v-if="category == 'general'">
                            <label class="mb-2" for="input-days_last_used"><strong> {{ $translate('days_last_used')
                                    }}</strong></label>
                            <b-form-input id="input-days_last_used" v-model="queryForm.days_last_used" type="number"
                                :placeholder="$translate('days_last_used')"></b-form-input>
                        </b-col>

                        <template v-else>
                            <b-col class="mt-4" cols="12" md="4">
                                <b-form-group label-for="input-is_overdue" label="Type" v-slot="{ ariaDescribedby }">
                                    <b-form-radio-group id="input-is_overdue" v-model="queryForm.is_overdue"
                                        :options="[{ text: 'Status', value: false }, { text: 'Overdue', value: true }]"
                                        :aria-describedby="ariaDescribedby" name="is_overdue"
                                        stacked></b-form-radio-group>
                                </b-form-group>
                            </b-col>

                            <template v-if="queryForm.is_overdue">
                                <b-col class="mt-4" md="4" cols="12">
                                    <label label-for="input-min_amount_overdue" class="mb-2"><strong> {{
                                        $translate('min_amount_overdue') }}</strong></label>
                                    <b-form-input id="input-min_amount_overdue" v-model="queryForm.min_amount_overdue"
                                        type="number" min="0" step="any"
                                        :placeholder="$translate('min_amount_overdue')"></b-form-input>
                                </b-col>

                                <b-col class="mt-4" md="4" cols="12">
                                    <label label-for="input-days_overdue" class="mb-2"><strong> {{
                                        $translate('days_overdue')
                                            }}</strong></label>
                                    <b-form-input id="input-days_overdue" v-model="queryForm.days_overdue" type="number"
                                        :placeholder="$translate('days_overdue')"></b-form-input>
                                </b-col>
                            </template>

                            <template v-else>
                                <b-col class="mt-4" md="4" cols="12">
                                    <label for="input-last_count" class="mb-3"><strong>{{
                                        $translate('last_count')
                                            }}</strong></label>
                                    <b-form-select id="input-last_count" v-model="queryForm.last_count"
                                        :options="[1, 2, 3]">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>{{
                                                $translate('select_last_count')
                                                }}</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>


                                <b-col class="mt-4" md="4" cols="12">
                                    <label for="input-recent_days" class="mb-3"><strong>{{
                                        $translate('recent_days') }}</strong></label>
                                    <b-form-select id="input-recent_days" v-model="queryForm.recent_days"
                                        :options="[30, 60, 90]">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>{{
                                                $translate('select_recent_days')
                                            }}</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </template>
                        </template>
                    </b-row>
                </form>
            </b-card-body>
        </b-card>
    </b-col>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    name: 'orders-queryfilters',
    components: {
        Multiselect
    },
    props: [
        'value', 'category'
    ],
    data() {
        return {
            queryForm: {
                types: [],
                customer_group_id: null,
                days_last_used: null,
                is_overdue: false,
                min_amount_overdue: null,
                days_overdue: null,
                last_count: null,
                recent_days: null
            }
        }
    },
    computed: {
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },


        customerGroups() {
            const customerGroups =
                this.$store.state.customerGroups.customer_groups
                || []
            return customerGroups
        },

        orderTypes() {
            return (this.$store.state.orderType.items || []).map(({ id, name }) => ({ id, name }))
        },

        typeOptions: {
            get() {
                const {
                    orderTypes,
                    queryForm: { types }
                } = this
                return (types || []).map(id => orderTypes.find(x => x.id == id))
            },
            set(_items) {
                this.$set(this.queryForm, 'types', (_items || []).map(x => x.id))
            },
        },
    },
    mounted() {
        this.$store.dispatch("orderType/fetchAll");
        this.$store.dispatch('customerGroups/fetchAll')

        const parsedValue = this.value ? JSON.parse(this.value) : {};
        for (const key in this.queryForm) {
            this.$set(this.queryForm, key, parsedValue[key] ?? null)
        }
    },
    watch: {
        queryForm: {
            handler: function (_value) {
                this.$emit("input", JSON.stringify(_value))
            },
            deep: true
        }
    },
    methods: {


    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>
